6 <template>
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <!-- Dashboard -->
      <li class="nav-item" v-if="canViewDashboard">
        <sidenav-collapse to="/dashboard" activeRoute="dashboard" navText="Dashboard">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Admin - Users -->
      <li class="nav-item" v-if="canViewUsers">
        <sidenav-collapse
            navText="Users"
            :children="[
            { to: '/admin/users', navText: 'All Users', activeRoute: 'UsersList', icon: 'group' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">group</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Real Estate -->
      <li class="nav-item">
        <sidenav-collapse to="/compounds" activeRoute="compounds" navText="Compounds">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">apartment</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse to="/developers" activeRoute="developers" navText="Developers">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">engineering</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse to="/areas" activeRoute="areas" navText="Areas">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">location_city</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse to="/properties" activeRoute="properties" navText="Properties">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">home</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- CRM -->
      <li class="nav-item">
        <sidenav-collapse to="/leads" activeRoute="leads" navText="Leads">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse to="/lead-stage-requests" activeRoute="lead-stage-requests" navText="Lead Stage Requests">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">fact_check</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse to="/meeting-requests" activeRoute="meeting-requests" navText="Meeting Requests">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">meeting_room</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Finance -->
      <li class="nav-item">
        <sidenav-collapse to="/banks" activeRoute="banks" navText="Banks">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">account_balance</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Education -->
      <li class="nav-item">
        <sidenav-collapse to="/learn-videos" activeRoute="learn-videos" navText="Learn Videos">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">ondemand_video</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse to="/learn-faqs" activeRoute="learn-faqs" navText="Learn FAQs">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">help</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Marketing -->
      <li class="nav-item">
        <sidenav-collapse to="/slides" activeRoute="SlideList" navText="Slides">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">collections</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Admin - Contracts -->
      <li class="nav-item" v-if="canManageContracts">
        <sidenav-collapse
            navText="Contracts Admin"
            :children="[
            { to: '/admin/contract-template', navText: 'Master Template', activeRoute: 'MasterTemplate', icon: 'description' },
            { to: '/admin/executed-contracts', navText: 'Signed Repository', activeRoute: 'ExecutedContracts', icon: 'assignment_turned_in' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">history_edu</i>
          </template>
        </sidenav-collapse>
      </li>

    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import permissionsMixin from "@/mixins/permissions";

export default {
  name: "SidenavList",
  components: { SidenavCollapse },
  mixins: [permissionsMixin],
  computed: {
    canViewDashboard() {
      // Only allow dashboard access if user has specific dashboard permission or is admin
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view dashboard', 'view-dashboard'
      ]);
    },
    canViewUsers() { // New computed property for Users
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view users', 'view-users',
        'create users', 'create-users',
        'edit users', 'edit-users'
      ]);
    },
    canCreateModerators() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'create users', 'create-users'
      ]);
    },
    canViewWallet() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view wallets', 'view-wallets',
        'manage wallets', 'manage-wallets',
        'manage wallet', 'manage-wallet'
      ]);
    },
    canManageContracts() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'manage contracts', 'manage-contracts',
        'view contracts', 'view-contracts'
      ]);
    },
  }
};
</script>
